import { Design } from 'blaze-ui/icons'

export const meta = {
  type: 'post',
  channel: 'post',
  title: 'Wizard',
  previewUrl: '',
  icon: Design,
}
